var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceContent0101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60.0001,
    fill: "#FABB00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5761 25.8601C40.9902 25.6451 41.2502 25.2173 41.2502 24.7507C41.2502 24.284 40.9902 23.8562 40.5761 23.6412L24.7259 15.414C24.3384 15.2129 23.874 15.2285 23.5009 15.4552C23.1639 15.66 22.9454 16.0102 22.9063 16.3978C22.8639 16.5235 22.8408 16.6582 22.8408 16.7982V43.7982C22.8408 44.4886 23.4005 45.0482 24.0908 45.0482C24.7812 45.0482 25.3408 44.4886 25.3408 43.7982V33.7682L40.5761 25.8601ZM25.4 30.9207L25.4 18.5806L37.2869 24.7507L25.4 30.9207Z",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceContent0101);
export default __webpack_public_path__ + "static/media/service-content01-01.0e95d84119184f3f0d9955bd51d74cea.svg";
export { ForwardRef as ReactComponent };